import { useEffect, useState } from "react";

type Direction = "ltr" | "rtl";

export type HtmlDirection = {
  direction: Direction;
};

export const useHtmlDirection = (): HtmlDirection => {
  const [direction, setDirection] = useState<Direction>("ltr");

  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    const updateDirection = () => {
      const htmlDirection = document.documentElement.dir as Direction;
      setDirection(htmlDirection || "ltr"); // Default to 'ltr' if no direction is set
    };

    // Set initial direction
    updateDirection();

    // Create a MutationObserver to watch for changes to the dir attribute
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "dir"
        ) {
          updateDirection();
        }
      });
    });

    // Start observing the document element for attribute changes
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["dir"],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    direction,
  };
};
